import * as React from "react";

export const BorderTopSVG = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="16" width="16" height="16" rx="2" transform="rotate(90 16 0)" fill="white"/>
    <rect x="15.25" y="0.75" width="14.5" height="14.5" rx="1.25" transform="rotate(90 15.25 0.75)" stroke="#7D8492" stroke-opacity="0.3" stroke-width="1.5"/>
    <mask id="path-3-inside-1_3872_5266" fill="white">
    <path d="M14 0C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0L14 0Z"/>
    </mask>
    <path d="M16 0V16V0ZM0 16L0 0L0 16ZM0 2C0 0.0670034 1.567 -1.5 3.5 -1.5L12.5 -1.5C14.433 -1.5 16 0.0670034 16 2C16 1.72386 15.1046 1.5 14 1.5L2 1.5C0.895431 1.5 0 1.72386 0 2ZM16 16H0H16Z" fill={`${props.color ? props.color : "#052f35 "}`} mask="url(#path-3-inside-1_3872_5266)"/>
    </svg>
      
);
